import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import Seo from '../components/seo';
import {
  Section,
  TeaserSection,
  PricesSection,
  ContactSection,
} from '../components/section';
import createTranslate from '../utils/translator-provider';
import { PreviewCardWrapper } from '../components/card';
import { PAGES_INFO, TEMPLATES_INFO  } from '../utils/pages-info';
import {UTM_NEW_ADVERTISER } from '../utils/utm-constants'

export const Head = ({data}) => {
  return (
  <Seo title={data.page.title} description={data.page.seoDescription} path={PAGES_INFO.newAdvertiser.path} />
)}
const renderItemGroup = (itemGroupObject) =>
    itemGroupObject &&
    itemGroupObject.map(({ items }, key) => (
      <div key={key}>
        {items.map((item) => {
          if (item.__typename === "ContentfulItemGroup") {
            return (
              <>
                <h2>{item.title}</h2>
                {item.items[0].___typename !== "ContentfulItemGroup" ? (
                  <PreviewCardWrapper
                    displayTag={false}
                    items={item.items.map(c => {
                      return {
                        ...c,
                        pathPrefix: TEMPLATES_INFO.article.path,
                      };
                    })}
                  />
                ) : (
                  renderItemGroup(item.items)
                )}
              </>
            )
          }
        })}
      </div>
  ));
const NewAdvertiserPage = ({ data: { page = {} } }) => {
  const translate = createTranslate(page.translations);

  return (
    <Layout
      title={page.title}
      description={page.seoDescription}
      path={PAGES_INFO.newAdvertiser.path}
    >
      <TeaserSection
        backgroundAssets={page.sectionBackgrounds}
        sectionName={'New advertiser teaser section'}
        title={translate('newAdvertiser.teaserSection.title')}
        body={translate('newAdvertiser.teaserSection.body')}
      />
      <ArticlesSection itemGroups={page.itemGroups} />
      <PricesSectionWrapper translate={translate} area={{name: 'Uusimaa'}} />
      <ContactSection />
    </Layout>
  );
};

const ArticlesSection = ({itemGroups}) => {
  return (
    <Section className="py-12 md:py-32 bg-slate-dark">
      {renderItemGroup(itemGroups ?? [])}
    </Section>
  );
};
const PricesSectionWrapper = ({ translate, area }) => {
  return (
    <PricesSection
      areaName={area.name}
      title={translate('localAdvertising.pricesSection.title')}
      body={translate('localAdvertisingpricesSection.body')}
      linkText={translate('localAdvertising.pricesSection.link')}
      utm={UTM_NEW_ADVERTISER}
      className="!bg-pearl"
    />
  );
};

export const query = graphql`{
  page: contentfulPage(name: {eq: "New advertiser"}) {
    title
    itemGroups {
      __typename
      items {
        __typename
        ... on ContentfulArticle {
          ...article
        }
        ... on ContentfulItemGroup {
          title
          items {
            ... on ContentfulArticle {
              ...article
            }
          }
        }
      }
    }
    seoDescription
    sectionBackgrounds {
      name
      asset {
        gatsbyImageData
        file {
          contentType
          url
        }
        localFile {
          publicURL
          childImageSharp {
            gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
          }
        }
      }
      brightness
      useShadowForText
      objectPositionVertical
      objectPositionHorizontal
    }
    translations {
      key
      value {
        value
      }
    }
  }
}

fragment article on ContentfulArticle {
  id
  title
  previewText
  slug
  internal {
    type
  }
  previewImage {
    gatsbyImageData
    localFile {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: NONE, layout: CONSTRAINED)
      }
    }
  }
}`;

export default NewAdvertiserPage; 
